export enum SpecialCommissionsSettingsRuleType {
  NETTO_POINTS_RATE = "NETTO_POINTS_RATE",
  COMMISSION_AMOUNT_RATE = "COMMISSION_AMOUNT_RATE",
  MONTHLY = "MONTHLY",
  ONE_TIME = "ONE_TIME",
}

export enum SpecialCommissionsReport {
  INCLUDED = "INCLUDED",
  EXCLUDED = "EXCLUDED",
}

export enum SpecialCommissionsReportScope {
  PAYER = "PAYER",
  PAYEE = "PAYEE",
  PAYER_AND_PAYEE = "PAYER_AND_PAYEE",
}
